export default __webpack_public_path__ + "static/media/dash.9578282c.png";